import { Environment, TenantComplianceFormEntityType } from "../models";
import { find } from "lodash";

export function getEntityInEnvironment<T>(
  environment: Environment,
  entityType: TenantComplianceFormEntityType,
  entityId: string,
): T | undefined {
  let toReturn: T;
  switch (entityType) {
    case "ENVIRONMENT":
      toReturn = environment as any;
      break;
    case "APP":
      toReturn = find(environment.apps || [], {
        uid: entityId,
      }) as any;
      break;
    case "FLOW":
      toReturn = find(environment.flows || [], {
        uid: entityId,
      }) as any;
      break;
    case "DESKTOPFLOW":
      toReturn = find(environment.desktopFlows || [], {
        uid: entityId,
      }) as any;
      break;
    case "BOT":
      toReturn = find(environment.bots || [], {
        uid: entityId,
      }) as any;
      break;
  }
  return toReturn;
}
